import { Outlet } from "react-router-dom";

const ExitManagementRoot = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ExitManagementRoot;
